import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { deleteComments } from "@/modules/lead-page/api/lead-page.api";
import useAuth from "@/modules/common/hooks/auth.hook";
import { toast } from "react-toastify";
import {
  BULK_MOVE_LOCK_MESSAGE,
  isBulkMoveConflictError,
} from "@/modules/common/utils";

const useDeleteComments = () => {
  const [dialogOpenConfirm, setDialogOpenConfirm] = useState(false);
  const [dialogOpenFeedback, setDialogOpenFeedback] = useState(false);
  const [onMouseHover, setOnMouseHover] = useState(false);
  const { user } = useAuth();

  const deleteCommentMutation = useMutation(
    (comment_id: number | string | undefined) => deleteComments(comment_id),
    {
      onSuccess: () => {
        toast.success("Comment deleted successfully", {
          position: "bottom-left",
        });

        queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
      },
      onError: (error: unknown) => {
        if (isBulkMoveConflictError(error)) {
          toast.warning(BULK_MOVE_LOCK_MESSAGE, {
            position: "bottom-left",
            autoClose: 5000,
          });
          return;
        }
        setDialogOpenFeedback(true);
      },
    }
  );

  const handleDeleteComments = (comment_id: number | string | undefined) => {
    deleteCommentMutation.mutate(comment_id);
    setDialogOpenConfirm(false);
  };

  return {
    handleDeleteComments,
    setDialogOpenFeedback,
    setDialogOpenConfirm,
    setOnMouseHover,
    dialogOpenConfirm,
    dialogOpenFeedback,
    onMouseHover,
    errorDeleting: deleteCommentMutation.isError,
    loadDeleting: deleteCommentMutation.isLoading,
    userUId: user?.["cognito:username"],
  };
};

export default useDeleteComments;
